import React from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import Img1 from '../images/boxing.jpg';
import Img2 from '../images/house-1.webp';
import Img3 from '../images/house-2.webp';
import Img4 from '../images/storing.jpg';

const Services = () => {
  const { t } = useTranslation();

  return (
    <div className="my-4 py-4" id='services'>
      <h1 className="my-2 text-center text-3xl text-blue-900 uppercase font-bold">{t('services.title')}</h1>
      <div className='flex justify-center'>
        <div className='w-80 border-b-4 border-blue-900 mb-8'></div>
      </div>

      <div className="px-4">
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-5">

          {/* Service Card 1 */}
          <div className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:scale-105 rounded-lg shadow-2xl p-3 min-h-max">
            <div className="m-2 text-justify text-sm">
              <h4 className="font-semibold my-4 text-lg md:text-2xl text-center mb-4 h-12">{t('services.cards.relocation.title')}</h4>
              <p className="text-md font-medium leading-5 h-auto md:h-48">
                {t('services.cards.relocation.desc')}
              </p>
              <div className="flex justify-center my-4">
                <Link to="/get-demo" className="text-white bg-blue-900 hover:bg-blue-800 inline-flex items-center justify-center w-full px-6 py-3 my-4 text-lg shadow-xl rounded-xl">
                  {t('services.cards.relocation.button')}
                  <svg className="w-4 h-4 ml-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </Link>
              </div>
            </div>
          </div>

          {/* Service Card 2 */}
          <div className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:scale-105 rounded-lg shadow-2xl p-3">
            <div className="m-2 text-justify text-sm">
              <h4 className="font-semibold my-4 text-lg md:text-2xl text-center mb-4 h-12">{t('services.cards.office.title')}</h4>
              <p className="text-md font-medium leading-5 h-auto md:h-48">
                {t('services.cards.office.desc')}
              </p>
              <div className="flex justify-center my-4">
                <Link to="/get-demo" className="text-white bg-blue-900 hover:bg-blue-800 inline-flex items-center justify-center w-full px-6 py-3 my-4 text-lg shadow-xl rounded-xl">
                  {t('services.cards.office.button')}
                  <svg className="w-4 h-4 ml-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </Link>
              </div>
            </div>
          </div>

          {/* Service Card 3 */}
          <div className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:scale-105 rounded-lg shadow-2xl p-3">
            <div className="m-2 text-justify text-sm">
              <h4 className="font-semibold my-4 text-lg md:text-2xl text-center mb-4 h-12">{t('services.cards.storage.title')}</h4>
              <p className="text-md font-medium leading-5 h-auto md:h-48">
                {t('services.cards.storage.desc')}
              </p>
              <div className="flex justify-center my-4">
                <Link to="/get-demo" className="text-white bg-blue-900 hover:bg-blue-800 inline-flex items-center justify-center w-full px-6 py-3 my-4 text-lg shadow-xl rounded-xl">
                  {t('services.cards.storage.button')}
                  <svg className="w-4 h-4 ml-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </Link>
              </div>
            </div>
          </div>

          {/* Service Card 4 */}
          <div className="bg-white transition-all ease-in-out duration-400 overflow-hidden text-gray-700 hover:scale-105 rounded-lg shadow-2xl p-3">
            <div className="m-2 text-justify text-sm">
              <h4 className="font-semibold my-4 text-lg md:text-2xl text-center mb-4 h-12">{t('services.cards.elevator.title')}</h4>
              <p className="text-md font-medium leading-5 h-auto md:h-48">
                {t('services.cards.elevator.desc')}
              </p>
              <div className="flex justify-center my-4">
                <Link to="/get-demo" className="text-white bg-blue-900 hover:bg-blue-800 inline-flex items-center justify-center w-full px-6 py-3 my-4 text-lg shadow-xl rounded-xl">
                  {t('services.cards.elevator.button')}
                  <svg className="w-4 h-4 ml-1" fill="currentColor" viewBox="0 0 20 20">
                    <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                  </svg>
                </Link>
              </div>
            </div>
          </div>

        </div>
      </div>

      <div className='px-4'>
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 mt-12">
          {[Img1, Img2, Img3, Img4].map((img, index) => (
            <div key={index} className="rounded-xl shadow-lg overflow-hidden flex justify-center items-center">
              <img
                src={img}
                alt={`Gallery ${index + 1}`}
                loading="lazy"
                className="max-w-[750px] max-h-[350px] w-full h-auto object-cover rounded-lg hover:scale-135 transition-transform duration-500"
              />
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};
// #2399D5
export default Services;
